import React, { useState } from 'react';
import { Send, Sparkles } from 'lucide-react';

export const RequestDestination = () => {
  const [destination, setDestination] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (destination.trim()) {
      // Aquí podrías integrar con un formulario de Google Forms o un endpoint
      // Por ahora, solo mostramos el mensaje de éxito
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        setDestination('');
      }, 3000);
    }
  };

  return (
    <section className="py-16 bg-gradient-to-br from-orange-50 to-red-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-orange-200 to-red-200 rounded-full blur-3xl opacity-20 -mr-32 -mt-32"></div>
            
            <div className="relative z-10">
              <div className="flex items-center justify-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center">
                  <Sparkles className="w-8 h-8 text-white" />
                </div>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-4">
                ¿No encuentras tu destino?
              </h2>
              
              <p className="text-lg text-gray-600 text-center mb-8">
                Sugiere un nuevo destino y lo añadiremos lo antes posible. ¡Tu opinión cuenta!
              </p>
              
              {!submitted ? (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="relative">
                    <input
                      type="text"
                      value={destination}
                      onChange={(e) => setDestination(e.target.value)}
                      placeholder="Ej: Portugal, Grecia, Bali..."
                      className="w-full px-6 py-4 rounded-full border-2 border-gray-200 focus:border-orange-500 focus:outline-none text-lg transition-colors"
                      required
                    />
                  </div>
                  
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-orange-600 to-red-600 text-white font-semibold py-4 rounded-full hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2"
                  >
                    <Send className="w-5 h-5" />
                    <span>Enviar sugerencia</span>
                  </button>
                </form>
              ) : (
                <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-6 text-center">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-lg font-semibold text-green-800">
                    ¡Gracias por tu sugerencia!
                  </p>
                  <p className="text-sm text-green-600 mt-2">
                    Trabajaremos para añadir "{destination}" pronto
                  </p>
                </div>
              )}
              
              <p className="text-sm text-gray-500 text-center mt-6">
                Las sugerencias más solicitadas serán priorizadas
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
